var _g, _ellipse, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_764_33082)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 33.5,
    ry: 31.5,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 29.3125,
    ry: 27.5625,
    fill: "#01537A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8209 34.1489L36.0648 28.0184C35.5007 27.2946 34.413 27.2946 33.849 28.0184L29.0524 34.1489C28.3283 35.0678 29.0113 36.3928 30.1812 36.3928H32.5975V47.0519C32.5975 47.4909 32.9617 47.8525 33.4032 47.8525H36.4695C36.9115 47.8525 37.2751 47.4909 37.2751 47.0519V36.3928H39.6921C40.8613 36.3928 41.545 35.0678 40.8209 34.1489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6007 20.0023C26.9544 20.0023 26.4314 19.4816 26.4314 18.8395C26.4314 18.2011 26.9544 17.6804 27.6007 17.6804C28.2463 17.6804 28.8104 18.2011 28.8104 18.8395C28.7699 19.4816 28.2463 20.0023 27.6007 20.0023ZM23.9734 20.0023C23.3277 20.0023 22.763 19.4816 22.763 18.8395C22.763 18.2011 23.2867 17.6804 23.9734 17.6804C24.619 17.6804 25.1426 18.2011 25.1426 18.8395C25.1837 19.4816 24.619 20.0023 23.9734 20.0023ZM20.3872 20.0023C19.7415 20.0023 19.2179 19.4816 19.2179 18.8395C19.2179 18.2011 19.7415 17.6804 20.3872 17.6804C21.0297 17.6804 21.5564 18.2011 21.5564 18.8395C21.5564 19.4816 21.0297 20.0023 20.3872 20.0023ZM51.3406 14.7944H18.5312C17.0015 14.7944 15.7917 16.0346 15.7917 17.5182V42.0028C15.7917 43.5235 17.0426 44.7675 18.5312 44.7675H28.5695C28.8888 44.7675 29.1746 44.487 29.1746 44.1656V41.8815C29.1746 41.5601 28.8888 41.2796 28.5695 41.2796H19.4595C19.3369 41.2796 19.2584 41.2022 19.2584 41.0803V22.8883H50.6134V41.1211C50.6134 41.2022 50.5318 41.3205 50.4129 41.3205H41.3061C40.9836 41.3205 40.6978 41.601 40.6978 41.9217V44.2065C40.6978 44.5272 40.9836 44.8077 41.3061 44.8077H51.3406C52.8703 44.8077 54.0807 43.5644 54.0807 42.0809V17.559C54.0807 16.0346 52.8703 14.7944 51.3406 14.7944Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_33082",
    x: 0,
    y: 0,
    width: 69,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_33082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_33082",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons7);
export default __webpack_public_path__ + "static/media/Icons7.18178391f30de835025f87aed322b0f6.svg";
export { ForwardRef as ReactComponent };